import { RichText } from '@brunommsilva/react-foundations';

import { gradient } from '../assistant-theme';
import AbstractMessageBubble from './abstract-message-bubble';

/** What the user typed: line breaks included, markdown left alone, :shortcodes: turned into emoji. */
export default function UserMessageBubble({ text }: { text: string }) {
  return (
    <AbstractMessageBubble
      side="end"
      bubbleSx={(theme) => ({
        background: gradient(theme),
        color: 'primary.contrastText',
        whiteSpace: 'pre-wrap',
      })}
    >
      <RichText text={text} emoji />
    </AbstractMessageBubble>
  );
}
